import type { TextInputProps } from '@mantine/core';
import { TextInput } from '@mantine/core';

const TextInputDefaultProps = {
  radius: 'sm',
  size: 'md',
};

const TextInputDefaults = TextInput.extend({
  defaultProps: TextInputDefaultProps,
});

export { TextInput, TextInputDefaults };
export type { TextInputProps };
